export default function GetMetadata() {
    return {
        appversion: navigator.appVersion.toString(),
        platform: navigator.platform,
        useragent: navigator.userAgent.toString(),
        vendor: navigator.vendor,
    }
}